var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoThinkTankWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "58px",
    viewBox: "0 0 57 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A1C1C09-C88F-4752-B77F-B66D7BBD56C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "26-Sixtbook_think_tank",
    transform: "translate(-1205.000000, -407.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_thinktank",
    transform: "translate(1205.000000, 407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.831000, 0.055200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2307,39.7837 L33.6817,40.0607 L33.6817,44.8717 L21.7097,44.8717 L21.7097,40.0607 L21.1597,39.7837 C16.2227,37.2917 13.1567,32.3207 13.1567,26.8107 C13.1567,18.7937 19.6787,12.2717 27.6957,12.2717 C35.7117,12.2717 42.2337,18.7937 42.2337,26.8107 C42.2337,32.3207 39.1677,37.2917 34.2307,39.7837 L34.2307,39.7837 Z M31.6697,55.5797 L23.7207,55.5797 L21.7097,53.5687 L21.7097,52.0667 L33.6817,52.0667 L33.6817,53.5687 L31.6697,55.5797 Z M21.7097,50.0667 L33.6827,50.0667 L33.6827,46.8717 L21.7097,46.8717 L21.7097,50.0667 Z M27.6957,10.2717 C18.5757,10.2717 11.1567,17.6907 11.1567,26.8107 C11.1567,32.8727 14.4177,38.3607 19.7097,41.2787 L19.7097,54.3967 L22.8927,57.5797 L32.4987,57.5797 L35.6817,54.3967 L35.6817,41.2787 C40.9727,38.3607 44.2337,32.8727 44.2337,26.8107 C44.2337,17.6907 36.8147,10.2717 27.6957,10.2717 L27.6957,10.2717 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "24.5969 21.3017 31.0329 23.7207 21.1119 27.4497 21.2789 29.3687 30.1039 31.0267 27.3539 32.0287 26.6959 32.9677 26.6959 39.6767 24.6059 39.6767 24.6059 41.6767 30.7849 41.6767 30.7849 39.6767 28.6959 39.6767 28.6959 33.6677 34.2169 31.6577 34.0599 29.7357 25.1629 28.0637 34.2269 24.6567 34.2269 22.7847 25.2999 19.4297"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "8.73079387e-13 27.6248 4.705 27.6248 4.705 25.6248 8.73079387e-13 25.6248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "50.632 27.6248 55.338 27.6248 55.338 25.6248 50.632 25.6248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "4.6966 42.0791 5.8726 43.6971 9.6786 40.9311 8.5036 39.3131"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "50.6419 11.1704 49.4659 9.5524 45.6589 12.3174 46.8339 13.9364"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    points: "37.1702 0.6186 35.2682 0.0006 33.8142 4.4756 35.7162 5.0946"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    points: "21.5237 4.476 20.0697 2.44249065e-14 18.1677 0.619 19.6217 5.094"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    points: "45.6585 40.9311 49.4665 43.6971 50.6415 42.0791 46.8345 39.3131"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    points: "4.6966 11.1704 8.5036 13.9364 9.6786 12.3174 5.8726 9.5524"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThinkTankWhite);
export default __webpack_public_path__ + "static/media/ico_think_tank_white.b5bbda03edcec521791c4dcb6fbbdc72.svg";
export { ForwardRef as ReactComponent };